// Show and hide a tooltip on hover
document.addEventListener('DOMContentLoaded', function () {
    // Funktion zur Erstellung des Tooltips
    function showTooltip(event) {
        // Textinhalt des Tooltips vom `data-tooltip`-Attribut holen
        const tooltipText = event.currentTarget.getAttribute('data-tooltip-text');

        // Tooltip-Element erstellen und mit Text füllen
        const tooltip = document.createElement('div');
        tooltip.classList.add('tooltip');
        tooltip.innerHTML = tooltipText.replace(/\r?\n/g, '<br>');

        // Tooltip zum DOM hinzufügen
        document.body.appendChild(tooltip);

        // // Tooltip-Position setzen
        const tooltipRect = event.currentTarget.getBoundingClientRect();
        const tooltipWidth = tooltip.offsetWidth;
        const elementWidth = tooltipRect.width;

        // Zentrierung des Tooltips über dem gehoverten Element
        tooltip.style.left = `${tooltipRect.left + window.scrollX + (elementWidth - tooltipWidth) / 2}px`;
        tooltip.style.top = `${tooltipRect.top + window.scrollY - tooltip.offsetHeight - 5}px`;

        // Event-Listener zum Entfernen des Tooltips hinzufügen
        event.currentTarget.addEventListener('mouseleave', hideTooltip);
        event.currentTarget._tooltipElement = tooltip;
    }

    // Tooltip entfernen
    function hideTooltip(event) {
        const tooltip = event.currentTarget._tooltipElement;
        if (tooltip) {
            tooltip.remove();
            event.currentTarget._tooltipElement = null;
        }
        event.currentTarget.removeEventListener('mouseleave', hideTooltip);
    }

    // Tooltip zu allen Elementen hinzufügen, die `data-tooltip`-Attribute haben
    document.querySelectorAll('[data-tooltip-text]').forEach(function (element) {
        element.addEventListener('mouseenter', showTooltip);
    });
});
